import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import { debounce } from 'lodash';
import { Button } from 'semantic-ui-react';

export default class DelayedFetchGrid extends Component {
  state = {
    filtered: this.props.defaultFilter ? this.props.defaultFilter : [],
    sorted: [],
    page: 0,
  };

  componentDidMount() {
    this.props.fetchData(this.getTableState());
  }

  componentDidUpdate(prevProps) {
    const { page } = this.state;
    const { pages } = this.props;

    if ((pages === 0 && page > 0) || (pages > 0 && page >= pages)) {
      this.setState({ page: Math.max(0, this.props.pages - 1) });
    }
  }

  getTableState = () => ({
    ...this.state,
    page: this.state.page + 1,
  });

  debouncedFetch = debounce(() => {
    this.props.fetchData(this.getTableState());
  }, 300);

  onFilteredChange = filtered => {
    this.setState({ filtered, page: 0 }, this.debouncedFetch);
  };

  onPageChange = page => {
    this.setState({ page }, () => {
      this.props.fetchData(this.getTableState());
    });
  };

  onSortedChange = sorted => {
    this.setState({ sorted }, () => {
      this.props.fetchData(this.getTableState());
    });
  };

  clearFilters = () => {
    this.setState({ filtered: [], sorted: [] }, () => {
      this.props.fetchData(this.getTableState());
    });
  };

  render() {
    const { showClearFiltersButton, fetchData, ...tableProps } = this.props;
    const { filtered, sorted, page } = this.state;

    return (
      <Fragment>
        {showClearFiltersButton && (
          <Button
            className={'btn--clear-filters'}
            disabled={filtered.length === 0 && sorted.length === 0}
            floated={'right'}
            onClick={this.clearFilters}
          >
            Clear Filters
          </Button>
        )}
        <ReactTable
          {...tableProps}
          filterable
          manual
          className={'grid--fixed-row-height'}
          filtered={filtered}
          onFilteredChange={this.onFilteredChange}
          onPageChange={this.onPageChange}
          onSortedChange={this.onSortedChange}
          page={page}
          sorted={sorted}
          pageSize={10}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/DelayedFetchGrid.js